var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "site-header",
      class: { open: _vm.isOpen },
      attrs: { id: "site-header" }
    },
    [
      _c("div", { staticClass: "wrap flex" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("nav", [
          _c(
            "ul",
            [
              _vm._l(_vm.data, function(link, index) {
                return _c("li", { key: index }, [
                  link !== null
                    ? _c("a", { attrs: { href: link.url } }, [
                        _vm._v(_vm._s(link.title))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  link !== null && link.children
                    ? _c("span", { staticClass: "icon icon-angle-down" })
                    : _vm._e(),
                  _vm._v(" "),
                  link !== null && link.children
                    ? _c(
                        "ul",
                        { staticClass: "child" },
                        _vm._l(link.children, function(child, index) {
                          return _c("li", { key: index }, [
                            _c("a", { attrs: { href: child.url } }, [
                              _vm._v(_vm._s(child.title))
                            ])
                          ])
                        }),
                        0
                      )
                    : _vm._e()
                ])
              }),
              _vm._v(" "),
              _vm._m(1)
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "hamburger mobile", on: { click: _vm.toggleMenu } },
          [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "logo", attrs: { href: "/home" } }, [
      _c("img", {
        attrs: { src: "/images/logo-reversed.svg", alt: "Pool Focus" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { staticClass: "button desktop", attrs: { href: "/contact-us" } },
        [_vm._v("Contact Us")]
      ),
      _vm._v(" "),
      _c("a", { staticClass: "mobile", attrs: { href: "/contact-us" } }, [
        _vm._v("Contact Us")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72144409", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72144409","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Header.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-72144409","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Header.vue
// module chunks = 0